module.exports = __webpack_public_path__ + "static/media/qrzn-cover.7702c73f.png";